import type { InvoiceComment } from "@/apis/gql/types";
import { useTenant } from "@/providers/session";
import { gql, useQuery } from "@apollo/client";

export const useGetAllInvoiceComments = ({
  invoiceId,
}: {
  invoiceId: string;
}) => {
  const { tenantId } = useTenant();

  const { data, error, loading, refetch } = useQuery<{
    invoiceComments: InvoiceComment[];
  }>(GET_ALL_INVOICE_COMMENTS_QUERY, {
    variables: {
      invoiceId,
      tenantId,
    },
  });

  return {
    invoiceComments: data?.invoiceComments ?? [],
    error,
    loading,
    refetch,
  };
};

export const GET_ALL_INVOICE_COMMENTS_QUERY = gql`
  query GetAllInvoiceComments($invoiceId: ID!, $tenantId: ID!) {
    invoiceComments(invoiceId: $invoiceId, tenantId: $tenantId) {
      invoiceCommentId
      invoiceId
      userId
      comment
      tenantId
      createdAt
      updatedAt
      user {
        userId
        name
        email
        image
      }
    }
  }
`;
